import type { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import type { ReactElement, ReactNode } from 'react';

/**
 * ControlAreaButtonのProps
 */
interface ControlAreaButtonProps {
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
  sx?: SxProps<Theme>;
  tooltip?: string;
}

/**
 * ControlArea用の共通ボタンコンポーネント
 */
export function ControlAreaButton({
  icon,
  onClick,
  disabled = false,
  ariaLabel,
  sx,
  tooltip,
}: ControlAreaButtonProps): ReactElement {
  const tooltipTitle = tooltip ?? ariaLabel ?? '';

  const button = (
    <Box
      component="span"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <IconButton onClick={onClick} disabled={disabled} size="small" aria-label={ariaLabel} sx={sx}>
        {icon}
      </IconButton>
    </Box>
  );

  if (!tooltipTitle) {
    return button;
  }

  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
      arrow
      enterDelay={150}
      enterNextDelay={150}
      disableTouchListener
    >
      {button}
    </Tooltip>
  );
}
